/**
 * Keeps route-level full-page states visually consistent without coupling them to a specific state.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from '@amzn/meridian/app-layout';
import Column from '@amzn/meridian/column';
import Masthead, { MastheadLink, MastheadTitle } from '@amzn/meridian/masthead';
import Text from '@amzn/meridian/text';
import { useTranslation } from 'src/arb-wrapper';

interface BasicLayoutProps {
  readonly children: React.ReactNode;
}

export const BasicLayout: React.FC<BasicLayoutProps> = ({ children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <AppLayout headerComponent={Masthead}>
      <Masthead size="small">
        <MastheadTitle>
          <MastheadLink
            href="/"
            onClick={(href: string) => {
              navigate(href);
            }}
          >
            <Text>{t('leela_title')}</Text>
          </MastheadLink>
        </MastheadTitle>
      </Masthead>
      <Column
        alignmentHorizontal="center"
        alignmentVertical="center"
        backgroundColor="subdued"
        minHeight="100%"
        spacingInset="500 600"
      >
        {children}
      </Column>
    </AppLayout>
  );
};
